import React from 'react';
import { useNavigate } from 'react-router';
import RankTierBadge from '../RankTierBadge';
import { CurrentUserRank, LeaderboardCategory, CATEGORY_CONFIG } from 'types/interfaces/leaderboard';
import './YourRankCallout.css';

interface YourRankCalloutProps {
  currentUserRank: CurrentUserRank | null;
  category: LeaderboardCategory;
  isLoggedIn: boolean;
}

const YourRankCallout: React.FC<YourRankCalloutProps> = ({
  currentUserRank,
  category,
  isLoggedIn,
}) => {
  const navigate = useNavigate();
  const statLabel = CATEGORY_CONFIG[category].statLabel;

  const formatDisplayValue = (value: number, cat: LeaderboardCategory): string => {
    if (cat === 'highest_rated') {
      return value.toFixed(1);
    }
    if (cat === 'rising_stars') {
      return `+${value}%`;
    }
    return value.toLocaleString();
  };

  // Not logged in
  if (!isLoggedIn) {
    return (
      <div className="your-rank-callout your-rank-callout--guest">
        <div className="your-rank-callout__message">
          <span className="your-rank-callout__icon">&#128100;</span>
          <span>Log in to see your rank on the leaderboard</span>
        </div>
        <button
          className="your-rank-callout__cta"
          onClick={() => navigate('/login')}
        >
          Log In
        </button>
      </div>
    );
  }

  // Logged in but not ranked
  if (!currentUserRank || currentUserRank.rank === null) {
    return (
      <div className="your-rank-callout your-rank-callout--unranked">
        <div className="your-rank-callout__message">
          <span className="your-rank-callout__icon">&#127942;</span>
          <span>Start trading to appear on the leaderboard!</span>
        </div>
        <button
          className="your-rank-callout__cta"
          onClick={() => navigate('/sending')}
        >
          Start Trading
        </button>
      </div>
    );
  }

  // Logged in and ranked
  return (
    <div className="your-rank-callout your-rank-callout--ranked">
      <div className="your-rank-callout__content">
        <div className="your-rank-callout__rank">
          <span className="your-rank-callout__rank-label">Your Rank</span>
          <span className="your-rank-callout__rank-value">#{currentUserRank.rank}</span>
        </div>
        <div className="your-rank-callout__tier">
          <RankTierBadge tier={currentUserRank.tier} size="medium" />
        </div>
        <div className="your-rank-callout__stat">
          <span className="your-rank-callout__stat-value">
            {formatDisplayValue(currentUserRank.displayValue, category)}
          </span>
          <span className="your-rank-callout__stat-label">{statLabel}</span>
        </div>
      </div>
    </div>
  );
};

export default YourRankCallout;
